module.exports = __webpack_public_path__ + "static/media/scala-milan-opera-hall.5e8146d9.wav";